// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__eb1iO","wrapper__":"style_wrapper____D7gWm","copyright":"style_copyright__94+hl","powered":"style_powered__hLt+x"};